module.exports = __webpack_public_path__ + "img/home-screenshot2.7e0a81b5.png";